import { BASE_API_URL } from '../apiConfig';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ConfirmationModal from '../components/ConfirmationModal';
import SocialLogin from '../components/SocialLogin';
import { useTranslation } from 'react-i18next';

const Register = () => {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        email: '',
        password: ''
    });
    const navigate = useNavigate();
    const [modalConfig, setModalConfig] = useState({ isOpen: false, message: '', redirect: false });

    React.useEffect(() => {
        if (localStorage.getItem('token')) {
            navigate('/');
        }
    }, [navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const res = await fetch(`${BASE_API_URL}/register`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        });
        if (res.ok) {
            const data = await res.json();
            // Automatizziamo il login dopo la registrazione
            localStorage.setItem('token', data.token);
            localStorage.setItem('user', JSON.stringify(data.user));

            const redirectUrl = localStorage.getItem('redirectAfterLogin') || '/';
            localStorage.removeItem('redirectAfterLogin');

            setModalConfig({
                isOpen: true,
                message: t("welcome_msg"),
                redirect: true,
                target: redirectUrl
            });
        } else {
            const data = await res.json();
            setModalConfig({ isOpen: true, message: data.error || t('register_error'), redirect: false });
        }
    };

    return (
        <div className="auth-page">
            <div className="auth-container">
                <div className="auth-header">
                    <h2>{t('register_title')}</h2>
                    <p className="subtitle">{t('register_subtitle')}</p>
                </div>
                <form onSubmit={handleSubmit} className="auth-form">
                    <div className="form-group">
                        <label>{t('first_name')}</label>
                        <input type="text" placeholder="Mario" onChange={e => setFormData({ ...formData, first_name: e.target.value })} required />
                    </div>
                    <div className="form-group">
                        <label>{t('last_name')} <i>({t('optional')})</i></label>
                        <input type="text" placeholder="Rossi" onChange={e => setFormData({ ...formData, last_name: e.target.value })} />
                    </div>
                    <div className="form-group">
                        <label>{t('email')}</label>
                        <input type="email" placeholder="mario.rossi@email.com" onChange={e => setFormData({ ...formData, email: e.target.value })} required />
                    </div>
                    <div className="form-group">
                        <label>{t('password')}</label>
                        <input type="password" placeholder="••••••••" onChange={e => setFormData({ ...formData, password: e.target.value })} required />
                    </div>
                    <button type="submit" className="primary-btn">{t('create_account')}</button>
                </form>
                <div className="auth-footer">
                    <p>{t('already_have_account')} <a href="/login">{t('login')}</a></p>
                </div>
                <SocialLogin setModalConfig={setModalConfig} />
            </div>

            <ConfirmationModal
                isOpen={modalConfig.isOpen}
                onClose={() => {
                    setModalConfig({ isOpen: false, message: '', redirect: false });
                    if (modalConfig.redirect) navigate(modalConfig.target || '/dashboard');
                }}
                title={modalConfig.redirect ? t("success") : t("attention")}
                message={modalConfig.message}
                isAlert={true}
            />
        </div>
    );
};

export default Register;

